const necessityCodes = {
  hygiene: 1,
  feeding: 2,
  movility: 3,
  comunication: 4,
  health: 5,
  transportation: 6,
  others: 7,
};

export default necessityCodes;
